import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";

const ShipmentNotification = ({ setUnreadCount }) => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  const token = Cookies.get("authToken");
  const officeCode = Cookies.get("officeCode");

  useEffect(() => {
    const fetchRecentShipments = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/api/shipment-details/partial-search?page=0&size=50`,
          { query: "" },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Office-Code": officeCode,
              "Content-Type": "application/json",
            },
          }
        );

        const { content = [] } = response.data;

        const transformed = content.map((s) => ({
          shipmentNumber: s.shipmentNumber,
          status: s.status,
          message:
            s.status === "CREATED"
              ? `Shipment #${s.shipmentNumber} is created and pending`
              : `Shipment #${s.shipmentNumber} is currently ${s.status?.toLowerCase()}`,
          timestamp: s.updatedDate || s.createdDate || new Date().toISOString(),
        }));

        setNotifications(transformed);
        if (setUnreadCount) setUnreadCount(transformed.length); // ✅ this line updated
      } catch (err) {
        console.error("Failed to fetch recent shipments:", err.response?.data || err.message);
        setNotifications([]);
        if (setUnreadCount) setUnreadCount(0); // ✅ fallback on error
      } finally {
        setLoading(false);
      }
    };

    fetchRecentShipments();
  }, [token, officeCode, setUnreadCount]); // ✅ correct dep name

  if (loading) {
    return (
      <div className="p-fluid-2 text-gray-600 text-fluid-sm">Loading shipment notifications...</div>
    );
  }

  if (!notifications.length) {
    return (
      <div className="p-fluid-2 text-gray-400 text-fluid-sm">No shipment notifications found.</div>
    );
  }

  return (
    <div className="flex flex-col gap-fluid-1.5 max-h-[24rem] overflow-y-auto px-fluid-2 py-fluid-2 scrollbar-thin">
      {notifications.map((item, idx) => (
        <div key={idx} className="p-fluid-1.5 bg-white hover:bg-gray-50 rounded-lg border">
          <p className="text-fluid-base font-semibold text-gray-800">
            Shipment {item.status === "CREATED" ? "Created" : "Update"}
          </p>
          <p className="text-fluid-sm text-gray-600">{item.message}</p>
          <p className="text-fluid-xs text-gray-400 mt-0.5">
            {new Date(item.timestamp).toLocaleString()}
          </p>
        </div>
      ))}
    </div>
  );
};

export default ShipmentNotification;
